import { state } from './state.js';
import { mutations } from './mutations.js';
import { getters } from './getters.js';

export const navigation = () => ({
    state,
    mutations,
    getters,
});
